import React from 'react';
import { useStaticCollections } from '../../context/StaticCollections';
import { strapiUrl } from '../../utils/constants.js';

const NominationZipExport = () => {
  const { nominationZipYears } = useStaticCollections();

  const downloadNomination = async (year, fileName) => {
    const downloadUrl = `${strapiUrl}/nomination-history/${fileName}`;

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const years = nominationZipYears?.yearFiles
    ? Object.keys(nominationZipYears.yearFiles).sort((a, b) => b - a)
    : [];

  return (
    <div className="col-md-6 mb-3">
      <div className="card h-100 d-flex flex-column admin-card">
        <div className="card-header">
          <h4 className="card-title">
            Download shortlisted and submitted nominations grouped by year
          </h4>
        </div>
        <div className="card-body">
          {years.length > 0 ? (
            <ul className="list-group">
              {years.map((year) => (
                <li
                  key={year}
                  className="list-group-item d-flex justify-content-between align-items-center py-2"
                  style={{ lineHeight: '1.2' }}
                >
                  <span>{year}</span>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-dark"
                    onClick={() =>
                      downloadNomination(
                        year,
                        nominationZipYears.yearFiles[year],
                      )
                    }
                    aria-label={`Download nominations for ${year}`}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={`Download shortlisted and submitted nominations for ${year}`}
                  >
                    <i className="bi bi-download" />
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-muted">No nomination archives available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NominationZipExport;
